<div class="row">
  <div class="col-12 text-center">
    <h1 class="text-white mb-3">Drop <span class="text-primary"> Resume &amp; Get </span> Your Desired Job</h1>
    <p class="lead mb-4 mb-lg-5 font-weight-normal">Find Jobs, Employment &amp; Career Opportunities</p>
    <div class="job-search-field">
      <div class="job-search-item">
        <form class="form row">
          <div class="col-lg-5">
            <div class="form-group">
              <div class="d-flex">
                <label>What</label>
                <span class="ml-auto">e.g. job, company, title</span>
              </div>
              <div class="position-relative left-icon">
                <input type="text" class="form-control" name="job_title" placeholder="Job title, skill or company">
                <i class="fas fa-search"></i>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="form-group">
              <div class="d-flex">
                <label>Where</label>
                <span class="ml-auto">e.g. city, county or postcode</span>
              </div>
              <div class="position-relative left-icon">
                <input type="text" class="form-control location-input" name="job_title"
                  placeholder="Town, city or postcode">
                <i class="far fa-compass"></i>
                <a href="#">
                  <div class="detect">
                    <span class="d-none d-sm-block">Detect</span>
                    <i class="fas fa-crosshairs"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-sm-12">
            <div class="form-group form-action">
              <button type="submit" class="btn btn-primary btn-lg"><i class="fas fa-search"></i> Find
                Jobs</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="job-tag mt-4">
      <ul class="justify-content-center">
        <li class="text-primary">Trending Keywords :</li>
        <ng-container *ngFor="let trendingKeyword of lookupStore.trendingKeywords | async;last as isLast">
          <li>{{trendingKeyword.name}}</li>
          <ng-container *ngIf="!isLast">,</ng-container>
        </ng-container>
      </ul>
    </div>

  </div>
</div>
